/**
 * Insurance Step - Fleet insurance configuration
 * Light theme
 */

import React from 'react';
import { Shield, Building2, FileText, HelpCircle } from 'lucide-react';

export function InsuranceStep({ data, updateData, onNext, onSkip }) {
  const handleFleetContractChange = (value) => {
    updateData({ hasFleetContract: value });
  };

  return (
    <div className="space-y-8 animate-fade-in">
      {/* Header */}
      <div className="text-center space-y-4">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-2xl">
          <Shield className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900">
          Parlons assurance
        </h2>
        <p className="text-gray-500">
          Ces informations nous aident à configurer le suivi des contrats
        </p>
      </div>

      {/* Fleet contract question */}
      <div className="space-y-4">
        <label className="text-gray-600 text-sm font-medium">
          Avez-vous un contrat flotte ?
        </label>
        <div className="grid grid-cols-3 gap-3">
          {[
            { value: true, label: 'Contrat flotte', desc: 'Un seul contrat pour tous' },
            { value: false, label: 'Individuel', desc: 'Un contrat par véhicule' },
            { value: null, label: 'Je ne sais pas', desc: 'À déterminer plus tard' },
          ].map((option) => (
            <button
              key={String(option.value)}
              onClick={() => handleFleetContractChange(option.value)}
              className={`
                p-4 rounded-xl border-2 transition-all text-center
                ${data.hasFleetContract === option.value
                  ? 'border-amber-500 bg-amber-50'
                  : 'border-gray-200 bg-white hover:border-gray-300 shadow-sm'
                }
              `}
            >
              <span className="text-gray-900 font-medium block">{option.label}</span>
              <span className="text-gray-400 text-xs mt-1 block">{option.desc}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Insurance details */}
      {data.hasFleetContract !== false && (
        <div className="space-y-4 animate-fade-in">
          <div className="space-y-2">
            <label className="text-gray-600 text-sm font-medium flex items-center gap-2">
              <Building2 className="w-4 h-4" />
              Assureur principal
            </label>
            <input
              type="text"
              value={data.insurerName}
              onChange={(e) => updateData({ insurerName: e.target.value })}
              placeholder="ex: AXA, Allianz, Groupama..."
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
            />
          </div>

          <div className="space-y-2">
            <label className="text-gray-600 text-sm font-medium flex items-center gap-2">
              <HelpCircle className="w-4 h-4" />
              Courtier (optionnel)
            </label>
            <input
              type="text"
              value={data.brokerName}
              onChange={(e) => updateData({ brokerName: e.target.value })}
              placeholder="ex: Gras Savoye, Marsh..."
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
            />
          </div>

          <div className="space-y-2">
            <label className="text-gray-600 text-sm font-medium flex items-center gap-2">
              <FileText className="w-4 h-4" />
              Numéro de contrat (optionnel)
            </label>
            <input
              type="text"
              value={data.policyNumber}
              onChange={(e) => updateData({ policyNumber: e.target.value })}
              placeholder="ex: FL-2024-001234"
              className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
            />
          </div>
        </div>
      )}

      {/* No contract message */}
      {data.hasFleetContract === false && (
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl text-center">
          <p className="text-gray-500">
            Pas de problème ! Vous pourrez ajouter vos assurances véhicule par véhicule plus tard.
          </p>
        </div>
      )}

      {/* Skip hint */}
      <div className="text-center">
        <button
          onClick={onSkip}
          className="text-gray-400 hover:text-gray-600 text-sm underline transition-colors"
        >
          Compléter plus tard
        </button>
      </div>
    </div>
  );
}

export default InsuranceStep;
